import { Group, Image, Stack, Text, ThemeIcon } from "@mantine/core";
import {
  IconChartLine,
  IconCoinEuro,
  IconFilePencil,
  IconPhoneCall,
  IconStar,
  IconThumbUp,
} from "@tabler/icons-react";
import type { ReactNode } from "react";

import ADVANTAGES from "@assets/avatars/advantages.svg";
import useAppTranslation from "@hooks/language/useAppTranslation";

export const RankedAdvantages: React.FC = () => {
  const { t } = useAppTranslation("components.rankedAdvantages");

  const card = (label: string, description: string, icon: ReactNode) => (
    <Group
      className="hover-scale flex-1 items-start rounded-xl border border-primary-light border-solid bg-primary-darker p-6"
      wrap="nowrap"
    >
      <ThemeIcon variant="transparent" className="pt-2">
        {icon}
      </ThemeIcon>
      <div>
        <Text className="pb-3 font-bold text-[24px] text-white">{label}</Text>
        <Text className="font-inter text-[16px] text-primary-light-text">
          {description}
        </Text>
      </div>
    </Group>
  );

  return (
    <div className="py-20 text-primary-light-text md:px-10">
      <div className="max-w-[600px] pb-16">
        <Text className="pb-3 font-bold text-[36px] text-white">
          {t("title")}
        </Text>
        <Text className="font-inter text-[16px] text-primary-dark-text">
          {t("description")}
        </Text>
      </div>
      <Group className="md:flex-nowrap" justify="center">
        <Stack>
          {card(
            t("items.ranked.label"),
            t("items.ranked.description"),
            <IconStar color="white" />,
          )}
          {card(
            t("items.lvl30.label"),
            t("items.lvl30.description"),
            <IconChartLine color="white" />,
          )}
          {card(
            t("items.unverifiedEmail.label"),
            t("items.unverifiedEmail.description"),
            <IconFilePencil color="white" />,
          )}
        </Stack>
        <Image h={"auto"} src={ADVANTAGES} w={"auto"} alt={t("altAhri")} />
        <Stack>
          {card(
            t("items.advantageousPrice.label"),
            t("items.advantageousPrice.description"),
            <IconCoinEuro color="white" />,
          )}
          {card(
            t("items.positiveReviews.label"),
            t("items.positiveReviews.description"),
            <IconThumbUp color="white" />,
          )}
          {card(
            t("items.frenchSupport.label"),
            t("items.frenchSupport.description"),
            <IconPhoneCall color="white" />,
          )}
        </Stack>
      </Group>
    </div>
  );
};
